import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Grid from "components/grid/grid";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

interface SubmitModalFormProps {
  onSubmit: () => Promise<any>;
  onClose: () => Promise<void>;
}

const SubmitModalForm: FunctionComponent<SubmitModalFormProps> = ({
  onClose,
  onSubmit,
}) => {
  const schema = yup.object({}).required();

  const methods = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {},
  });

  const handleSubmit = async () => {
    onSubmit();
  };

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton, text: "Lähetä tarkastettavaksi" },
  ];

  return (
    <Form methods={methods} onSubmit={handleSubmit}>
      <Grid>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default SubmitModalForm;
